module.exports = __webpack_public_path__ + "static/img/fgx.dc5f5f71.png";